var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49989 6.27419C7.48 3.982 9.90107 3.03777 11.88 3.00111V3L11.9399 3.00028L11.9999 3V3.00111C13.9788 3.03777 16.3999 3.982 17.38 6.27419C17.9578 7.62549 18.011 8.50832 18.0631 9.37382C18.1012 10.0062 18.1387 10.6294 18.38 11.4194C18.5693 12.0393 19.0723 12.7619 19.5876 13.5021C20.6274 14.996 21.7173 16.5617 20.38 17.5H15.9691C15.723 19.4732 14.0398 21 12 21C9.96019 21 8.277 19.4732 8.03095 17.5H3.49991C2.16259 16.5617 3.25243 14.996 4.29229 13.5021L4.29229 13.5021C4.80756 12.7619 5.31056 12.0393 5.49989 11.4194C5.74115 10.6294 5.77869 10.0062 5.81678 9.37381C5.86892 8.50832 5.92209 7.62549 6.49989 6.27419Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.435588b760f3a0b51db8fba36c561393.svg";
export { ForwardRef as ReactComponent };